export default {
  title: 'Warenkorb',
  buttons: {
    login_to_checkout: 'Anmelden zum Bezahlen',
    checkout: 'Zur Kasse',
  },
  go_to_menu: 'Zum Menü gehen',
};
